import { TextField } from "@mui/material";
import { CnpjMask } from "../../../../components/Mask/DelendTextMask";
import { FieldErrors } from "react-hook-form";
import { LegalPersonInput } from "../../validation";

interface CnpfInputProps {
  register: any;
  errors: FieldErrors<LegalPersonInput>;
}

const CnpjInput: React.FC<CnpfInputProps> = ({register, errors}) => {
  return (
    <TextField
      fullWidth
      {...register("documentNumber")}
      label="CNPJ"
      required
      error={!!errors.documentNumber}
      helperText={errors.documentNumber?.message}
      variant="standard"
      InputProps={{ inputComponent: CnpjMask as any }}
    />
  );
};

export default CnpjInput;
